"use strict";

import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from "react";
import View from "react-native-web/dist/exports/View";
import PanResponder from "react-native-web/dist/exports/PanResponder";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var swipeDirections = {
  SWIPE_UP: "SWIPE_UP",
  SWIPE_DOWN: "SWIPE_DOWN",
  SWIPE_LEFT: "SWIPE_LEFT",
  SWIPE_RIGHT: "SWIPE_RIGHT"
};

if (typeof swipeDirections !== 'undefined' && swipeDirections && swipeDirections === Object(swipeDirections) && Object.isExtensible(swipeDirections) && !swipeDirections.hasOwnProperty('__filemeta')) {
  Object.defineProperty(swipeDirections, '__filemeta', {
    configurable: true,
    value: {
      name: "swipeDirections",
      filename: "node_modules/react-native-swipe-gestures/index.js"
    }
  });
}

var swipeConfig = {
  velocityThreshold: 0.3,
  directionalOffsetThreshold: 80,
  gestureIsClickThreshold: 5
};

function isValidSwipe(velocity, velocityThreshold, directionalOffset, directionalOffsetThreshold) {
  return Math.abs(velocity) > velocityThreshold && Math.abs(directionalOffset) < directionalOffsetThreshold;
}

var GestureRecognizer = function (_Component) {
  _inherits(GestureRecognizer, _Component);

  var _super = _createSuper(GestureRecognizer);

  function GestureRecognizer(props, context) {
    var _this;

    _classCallCheck(this, GestureRecognizer);

    _this = _super.call(this, props, context);
    _this.swipeConfig = _extends(swipeConfig, props.config);

    var responderEnd = _this._handlePanResponderEnd.bind(_assertThisInitialized(_this));

    var shouldSetResponder = _this._handleShouldSetPanResponder.bind(_assertThisInitialized(_this));

    _this._panResponder = PanResponder.create({
      onStartShouldSetPanResponder: shouldSetResponder,
      onMoveShouldSetPanResponder: shouldSetResponder,
      onPanResponderRelease: responderEnd,
      onPanResponderTerminate: responderEnd
    });
    return _this;
  }

  _createClass(GestureRecognizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.config !== prevProps.config) {
        this.swipeConfig = _extends(swipeConfig, this.props.config);
      }
    }
  }, {
    key: "_handleShouldSetPanResponder",
    value: function _handleShouldSetPanResponder(evt, gestureState) {
      return evt.nativeEvent.touches.length === 1 && !this._gestureIsClick(gestureState);
    }
  }, {
    key: "_gestureIsClick",
    value: function _gestureIsClick(gestureState) {
      return Math.abs(gestureState.dx) < swipeConfig.gestureIsClickThreshold && Math.abs(gestureState.dy) < swipeConfig.gestureIsClickThreshold;
    }
  }, {
    key: "_handlePanResponderEnd",
    value: function _handlePanResponderEnd(evt, gestureState) {
      var swipeDirection = this._getSwipeDirection(gestureState);

      this._triggerSwipeHandlers(swipeDirection, gestureState);
    }
  }, {
    key: "_triggerSwipeHandlers",
    value: function _triggerSwipeHandlers(swipeDirection, gestureState) {
      var _this$props = this.props,
          onSwipe = _this$props.onSwipe,
          onSwipeUp = _this$props.onSwipeUp,
          onSwipeDown = _this$props.onSwipeDown,
          onSwipeLeft = _this$props.onSwipeLeft,
          onSwipeRight = _this$props.onSwipeRight;
      var SWIPE_LEFT = swipeDirections.SWIPE_LEFT,
          SWIPE_RIGHT = swipeDirections.SWIPE_RIGHT,
          SWIPE_UP = swipeDirections.SWIPE_UP,
          SWIPE_DOWN = swipeDirections.SWIPE_DOWN;
      onSwipe && onSwipe(swipeDirection, gestureState);

      switch (swipeDirection) {
        case SWIPE_LEFT:
          onSwipeLeft && onSwipeLeft(gestureState);
          break;

        case SWIPE_RIGHT:
          onSwipeRight && onSwipeRight(gestureState);
          break;

        case SWIPE_UP:
          onSwipeUp && onSwipeUp(gestureState);
          break;

        case SWIPE_DOWN:
          onSwipeDown && onSwipeDown(gestureState);
          break;
      }
    }
  }, {
    key: "_getSwipeDirection",
    value: function _getSwipeDirection(gestureState) {
      var SWIPE_LEFT = swipeDirections.SWIPE_LEFT,
          SWIPE_RIGHT = swipeDirections.SWIPE_RIGHT,
          SWIPE_UP = swipeDirections.SWIPE_UP,
          SWIPE_DOWN = swipeDirections.SWIPE_DOWN;
      var dx = gestureState.dx,
          dy = gestureState.dy;

      if (this._isValidHorizontalSwipe(gestureState)) {
        return dx > 0 ? SWIPE_RIGHT : SWIPE_LEFT;
      } else if (this._isValidVerticalSwipe(gestureState)) {
        return dy > 0 ? SWIPE_DOWN : SWIPE_UP;
      }

      return null;
    }
  }, {
    key: "_isValidHorizontalSwipe",
    value: function _isValidHorizontalSwipe(gestureState) {
      var vx = gestureState.vx,
          dy = gestureState.dy;
      var _this$swipeConfig = this.swipeConfig,
          velocityThreshold = _this$swipeConfig.velocityThreshold,
          directionalOffsetThreshold = _this$swipeConfig.directionalOffsetThreshold;
      return isValidSwipe(vx, velocityThreshold, dy, directionalOffsetThreshold);
    }
  }, {
    key: "_isValidVerticalSwipe",
    value: function _isValidVerticalSwipe(gestureState) {
      var vy = gestureState.vy,
          dx = gestureState.dx;
      var _this$swipeConfig2 = this.swipeConfig,
          velocityThreshold = _this$swipeConfig2.velocityThreshold,
          directionalOffsetThreshold = _this$swipeConfig2.directionalOffsetThreshold;
      return isValidSwipe(vy, velocityThreshold, dx, directionalOffsetThreshold);
    }
  }, {
    key: "render",
    value: function render() {
      return ___EmotionJSX(View, _extends({}, this.props, this._panResponder.panHandlers));
    }
  }]);

  return GestureRecognizer;
}(Component);

export default GestureRecognizer;

if (typeof GestureRecognizer !== 'undefined' && GestureRecognizer && GestureRecognizer === Object(GestureRecognizer) && Object.isExtensible(GestureRecognizer) && !GestureRecognizer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(GestureRecognizer, '__filemeta', {
    configurable: true,
    value: {
      name: "GestureRecognizer",
      filename: "node_modules/react-native-swipe-gestures/index.js"
    }
  });
}